import zoomAppModules from './zoomApp.module'
import presentationModules from './presentation/index'
import liveStatsV2 from './live-stats/live-stats.module'
import featureToggles from './feature-toggles.module'
import systemConnection from './system/system-connection.module'
import nextback from './nextback/nextback.module'
import kvSync from './kvSync.module'
import leaderboard from './leaderboard.module'
import websocket from './websocket.module'
import quiz from './quiz.module'
import participantModule from './participant.module'
import logger from './logger.module'
import submitedQuiz from './submitedQuiz.module'
import slideProgress from './slide-progress/slide-progress.module'
import audienceAudio from './audience-audio.module'
import embedApp from './embed-app/embed-app.module'

export default {
  zoomApp: zoomAppModules,
  ...presentationModules,
  liveStatsV2,
  featureToggles,
  systemConnection,
  nextback,
  kvSync,
  leaderboard,
  websocket,
  quiz,
  participantModule,
  logger,
  submitedQuiz,
  slideProgress,
  audienceAudio,
  embedApp,
}
